const scenario = [
  'Руководитель объясняет задачу.',
  'Сотрудник делает ошибку.',
  'Руководитель исправляет её сам.',
  'Сотрудник не понимает, что именно сделал неправильно.',
  'В следующий раз ситуация повторяется.',
  'Руководитель окончательно убеждается, что «самому быстрее».',
];

const model = [
  'задача',
  'попытка сотрудника',
  'наблюдение',
  'вопросы',
  'обратная связь',
  'повторная попытка',
  'самостоятельное выполнение',
];

export default function NotDoingWork() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Наставник не должен делать работу за сотрудника
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Главная ошибка наставника: «Проще сделать самому». Вот типичный сценарий, который закрепляет зависимость сотрудника от руководителя:
        </p>

        <div className="grid sm:grid-cols-1 gap-3 max-w-4xl mx-auto mb-12">
          {scenario.map((s, i) => (
            <div key={i} className="flex items-start gap-3 bg-white rounded-lg border border-gray-200 p-4 hover:border-red-300 transition-colors">
              <div className="w-7 h-7 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                {i + 1}
              </div>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-teal-200 p-6 md:p-10 max-w-4xl mx-auto">
          <h3 className="text-base md:text-lg font-bold text-gray-900 text-center mb-6">
            Правильная модель развития
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {model.map((m, i) => (
              <span key={m} className="inline-flex items-center gap-2">
                <span className="bg-teal-50 border border-teal-200 text-teal-800 px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap">
                  {m}
                </span>
                {i < model.length - 1 && (
                  <i className="ri-arrow-right-line text-teal-400 text-sm"></i>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}